module.exports = __webpack_public_path__ + "static/media/Formstack_Sign_Product_Logo.8eff2ef7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Formstack_Sign_Product_Logo.svg
// module id = 604
// module chunks = 0